module.exports = __webpack_public_path__ + "img/Uppsala-354.311d78be.jpg";